module.exports = __webpack_public_path__ + "static/media/zoom.97e0af56.mp4";